<template>
  <div>
    <payment-verification :data="data" />
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @back-from-continue-back="handleBackFromContinueBack"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed } from 'vue';
import PaymentVerification from './PaymentVerification.vue';
import { useToast } from 'vue-toast-notification';

export default {
  name: 'PaymentStepFour',
  components: {
    FormNavigationButtons,
    'payment-verification': PaymentVerification,
  },
  props: {
    data: Object,
    updateField: Function,
    formPosition: Number,
    title: String,
    nextStep: Function,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  setup() {
    const store = useStore();
    const componentIdentifier = 'Payment-4';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = 'continue-back';
    const isButtonDisabled = false;

    const toast = useToast();

    // const isTriumphPayAllowedByPaymentTerms = computed(() => store.state.payments?.payment_terms?.some(term => term?.allowed_payment_methods?.includes('triumph_pay')));

    const newPaymentMethodType = computed(
      () => store.state.payments.newPaymentMethodType
    );
    const paymentType = computed(() => store.state.payments.payment_type);
    const savedPaymentTerm = computed(
      () => store.state.payments.saved_payment_term
    );

    // const verifyPayment = async () => {
    //   store.commit('addFormDebugMessage', componentIdentifier+": 'verifyPayment' called")
    //   // const isTriumphPayRendered = store.state.payments.rendered_payment?.[0]?.is_type === 'triumph_pay' || store.state.payments.rendered_payment?.is_type === 'triumph_pay';
    //   // const renderedPaymentMethod = store.state.payments.rendered_payment?.[0] || store.state.payments.rendered_payment;
    //   const verification_id = store.state.payments?.verification_id;
    //   const code = store.state.payments?.verification_code;
    //   let res = await store.dispatch("payments/verifyPaymentCode", { verification_id, code });
    //   if (res?.data?.status === "confirmed") {
    //     store.dispatch("payments/updateNestedField", { path: "errors", value: false });
    //     // store.dispatch("payments/updateNestedField", { path: "edit.payment_method", value: true });
    //     // store.commit('addFormDebugMessage', componentIdentifier+": Verification successful, redirecting to Payment-3 to continue new "+newPaymentMethodType.value+" payment method creation");
    //     return 'Payment-3';

    //     // if ((isTriumphPayRendered || (store.state.payments?.latest_payment_method?.[0]?.is_type === 'triumph_pay') && isTriumphPayAllowedByPaymentTerms.value)){
    //     //   this.$store.commit('payments/setTriumphPayDeclined', true);
    //     //   if(isTriumphPayRendered && Number(renderedPaymentMethod?.triumph_pay_select_carrier_rate) > 0 ){
    //     //     return 'Payment-1';
    //     //   }else{
    //     //     //Triumph Pay flow.
    //     //     store.commit("toggleDisabledButton", { bool: true, source: 'FormFlow #1' });
    //     //     store.commit('payments/setEditFactor', true);
    //     //     return 'Payment-2';
    //     //   }
    //     // } else {
    //     //   if(store.state.payments?.payment_type === 'factoring'){
    //     //     store.commit("toggleDisabledButton", { bool: true, source: 'FormFlow #2' });
    //     //     store.commit('payments/setEditFactor', true);
    //     //   }
    //     //   return 'Payment-2';
    //     // }
    //   } else {
    //     store.dispatch("payments/updateNestedField", {
    //       path: "errors",
    //       value: true,
    //     });
    //     return null;
    //   }
    // };

    const handleVerificationToast = (response) => {
      if (response?.status == 422) {
        toast?.open({
          message: 'Verification code is invalid. Please try again.',
          type: 'error',
          position: 'top-right',
          duration: 5000,
        });
      } else if (response?.status == 504) {
        toast?.open({
          message:
            'The server response timed out.  Please try your request again.  If this error continues, please contact service@highway.com.',
          // type: 'error',
          position: 'top-right',
          duration: '5000',
        });
      } else if (response?.status == 502) {
        toast?.open({
          message:
            'The server response timed out.  Please try your request again.  If this error continues, please contact service@highway.com.',
          // type: 'error',
          position: 'top-right',
          duration: 5000,
        });
      } else if (response?.status == 403) {
        toast?.open({
          message:
            'Unable to perform the action requested (403).  If you received this message in error, please contact service@highway.com',
          // type: 'error',
          position: 'top-right',
          duration: 5000,
        });
      }
    };

    const nextCheck1 = computed(
      () =>
        paymentType.value === 'factoring' ||
        savedPaymentTerm.value?.is_type === 'factoring'
    );

    const handleNext = async () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      // // Calling verifyPayment to ensure that user is authorized to edit previously saved payment method information
      // const navigationDestination = await verifyPayment();
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ': (handleNext) Submitting verification'
      );
      const verification_id = store.state.payments?.verification_id;
      const code = store.state.payments?.verification_code;
      let res = await store.dispatch('payments/verifyPaymentCode', {
        verification_id,
        code,
      });
      if (res?.data?.status === 'confirmed') {
        store.dispatch('payments/updateNestedField', {
          path: 'errors',
          value: false,
        });
        store.commit(
          'addFormDebugMessage',
          'VERIFICATION | ' +
            componentIdentifier +
            ': (handleNext) Verification successful'
        );
        if (nextCheck1.value) {
          store.commit(
            'addFormDebugMessage',
            'NEXT CHECK 1 | ' +
              componentIdentifier +
              ': (handleNext) nextCheck1 is TRUE (payment_type or saved_payment_term.is_type is factoring), navigating to Payment-2 to continue new factor creation'
          );
          return formRouter.moveToStepByIdentifier('Payment-2');
        } else {
          store.commit(
            'addFormDebugMessage',
            'NEXT CHECK 1 | ' +
              componentIdentifier +
              ': (handleNext) nextCheck1 is FALSE (neither payment_type nor saved_payment_term.is_type is factoring)'
          );
        }
        store.commit(
          'addFormDebugMessage',
          ': ' +
            componentIdentifier +
            ': Navigating to Payment-3 to continue new ' +
            newPaymentMethodType.value +
            ' payment method creation'
        );
        formRouter.moveToStepByIdentifier('Payment-3');
      } else {
        handleVerificationToast(res);
        store.commit(
          'addFormDebugMessage',
          'VERIFICATION | ' +
            componentIdentifier +
            ': (handleNext) Verification failed, showing errors and remaining on Payment-4'
        );
      }

      // if (navigationDestination && navigationDestination?.length > 0) {
      //   // store.commit('addFormDebugMessage', 'ERROR: '+componentIdentifier+": (handleNext) Verification successful, navigating to Payment-3 to continue new "+newPaymentMethodType.value+" payment method creation");
      //   // formRouter.moveToStepByIdentifier(navigationDestination);
      // } else {
      //   // store.commit('addFormDebugMessage', 'ERROR: '+componentIdentifier+": (handleNext) Verification failed, showing errors and remaining on Payment-4");
      // }
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      // Always skipping Payment-3, so we can go back to Payment-2
      formRouter.moveToStepByIdentifier('Payment-2');
    };

    const handleBackFromContinueBack = async () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBackFromContinueBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      store.commit(
        'addFormDebugMessage',
        componentIdentifier +
          ': Leaving verification without completing via Back, setting newPaymentMethodType, payment_source, and payment_body to null and navigating to Payment-2'
      );
      await store.dispatch('payments/nullifyNewPaymentMethodType');
      await store.dispatch('payments/setPaymentBody', null);
      formRouter.moveToStepByIdentifier('Payment-2');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleBackFromContinueBack,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
    };
  },
  computed: {
    isEmailRequiredForLogin: function () {
      return this.$store.state.carriers.isEmailRequiredForLogin;
    },
  },
  watch: {
    stepName: function (val) {
      if (val === 'Payment-4') {
        this.$store.dispatch('payments/sendVerificationCode', {
          isEmailRequired: this.isEmailRequiredForLogin,
        });
        const find = document.querySelector('#verification_code');
        setTimeout(() => {
          find.focus();
        }, 0);
      }
    },
  },
};
</script>
